import { Image, Empty, Spin, Button } from "antd";
import { Eye } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { getChannelCustomerPhotos } from "../../../api/ChannelCustomer";

// Số ảnh hiển thị mỗi trang (phân trang phía client)
const PAGE_LIMIT = 9;

export default function CustomerImgList({ channelCustomerId }: { channelCustomerId?: number | null }) {
    const [images, setImages] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);

    useEffect(() => {
        setPage(1);
        if (!channelCustomerId) {
            setImages([]);
            return;
        }
        let active = true;
        setLoading(true);
        getChannelCustomerPhotos(channelCustomerId, { page: 1, limit: PAGE_LIMIT })
            .then((res) => {
                if (!active) return;
                const urls = (res.data || [])
                    .map((p) => p.image_path)
                    .filter((u): u is string => !!u);
                setImages(urls);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => { active = false; };
    }, [channelCustomerId]);

    const visibleImages = useMemo(() => images.slice(0, page * PAGE_LIMIT), [images, page]);
    const remaining = images.length - visibleImages.length;

    return (
        <div>
            {/* Header */}
            <div className="flex items-center justify-between mt-3 mb-2">
                <span className="text-[10px] font-semibold uppercase tracking-wide text-[#8c8c8c]">
                    Hình ảnh khách gửi (Click vào để zoom)
                </span>
                {images.length > 0 && (
                    <span className="text-[10px] text-[#8c8c8c]">
                        {visibleImages.length}/{images.length}
                    </span>
                )}
            </div>

            {/* Images */}
            {loading ? (
                <div className="flex justify-center py-4">
                    <Spin size="small" />
                </div>
            ) : images.length === 0 ? (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Chưa có ảnh" />
            ) : (
                <>
                    <div className="max-h-[420px] overflow-y-auto pr-1">
                        <Image.PreviewGroup>
                            {/* 4 ảnh trên 1 hàng, ô vuông co giãn theo bề rộng */}
                            <div className="grid grid-cols-4 gap-2">
                                {visibleImages.map((src, index) => (
                                    <div className="border rounded-md overflow-hidden aspect-square" key={index}>
                                        <Image
                                            src={src}
                                            wrapperClassName="w-full h-full"
                                            className="object-cover"
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            preview={{
                                                mask: (
                                                    <div>
                                                        <Eye size={20} />
                                                    </div>
                                                )
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </Image.PreviewGroup>
                    </div>

                    {remaining > 0 && (
                        <div className="flex justify-center mt-2">
                            <Button size="small" type="link" onClick={() => setPage((p) => p + 1)}>
                                Xem thêm ({remaining})
                            </Button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
